/* eslint-disable no-undef */
import PropTypes from 'prop-types'
import React from 'react'
import Lightbox from 'react-images'
import { AdImagesBanners } from 'SRC/modules/ads/detail/components/Banners'

import { PhotosMobile } from '../PhotosMobile'
import { ImageTags } from './ImageTags'

export const Photos = ({ images, title, imageTags, deliveryInfo }) => {
	const [lightboxOpen, setLightboxOpen] = React.useState(false)
	const [currentImage, setCurrentImage] = React.useState(0)

	const openLightbox = (index) => {
		console.log('openLightbox', index)

		setLightboxOpen(true)
		setCurrentImage(index)
	}

	const closeLightbox = () => {
		setLightboxOpen(false)
		setCurrentImage(0)
	}

	const goToPrevious = () => {
		setCurrentImage(currentImage === 0 ? images.length - 1 : currentImage - 1)
	}

	const goToNext = () => {
		setCurrentImage(currentImage === images.length - 1 ? 0 : currentImage + 1)
	}

	const goToImage = (index) => {
		setCurrentImage(index)
	}

	const handleClickImage = () => {
		if (currentImage === images.length - 1) return
		goToNext()
	}

	const handleItemClick = (index) => {
		setCurrentImage(index)

		if (lightboxOpen) {
			closeLightbox()
		} else {
			openLightbox(index)
		}
	}

	const getCustomControls = () => {
		return [
			<AdImagesBanners key='ad-images-banners' currentImage={currentImage} />,
			<div className='image-sides image-left' key='image-left' onClick={goToPrevious}>
				<div className='arrow arrow-left'>
					<div className='arrow_icon arrow-left_icon' />
				</div>
			</div>,
			<div className='image-sides image-right' key='image-right' onClick={goToNext}>
				<div className='arrow arrow-right'>
					<div className='arrow_icon arrow-right_icon' />
				</div>
			</div>,
			<div className='lightbox-custom-header' key='lightbox-custom-header'>
				<span>{`${currentImage + 1}/${images.length}`}</span>
			</div>,
			<span key='empty' />
		]
	}

	const customControls = getCustomControls()

	const theme = {
		arrow__size__medium: {
			display: 'none'
		}
	}

	return images ? (
		<>
			<div className='vehicle-part-product-summary__photos-container vehicle-part-product-summary__photos-container-dt' style={{ position: 'relative' }}>
				<img src={images[0]?.src} alt={title} onClick={e => openLightbox(0)} style={{ objectFit: 'cover', aspectRatio: '4/3', height: '100%' }} />

				<ImageTags imageTags={imageTags} />
			</div>

			<PhotosMobile
				images={images}
				title={title}
				onClick={handleItemClick}
				currentImage={currentImage}
				imageTags={imageTags}
				deliveryInfo={deliveryInfo}
			/>

			<Lightbox
				currentImage={currentImage}
				images={images}
				isOpen={lightboxOpen}
				onClickImage={handleClickImage}
				onClickNext={goToNext}
				onClickPrev={goToPrevious}
				onClose={closeLightbox}
				onClickThumbnail={goToImage}
				showThumbnails
				backdropClosesModal
				customControls={[customControls]}
				showCloseButton
				theme={theme}
			/>
		</>
	) : null

}

Photos.propTypes = {
	images: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		src: PropTypes.string.isRequired,
	})).isRequired,
	title: PropTypes.string.isRequired,
	show_discount: PropTypes.bool.isRequired,
	discount: PropTypes.number.isRequired,
}
